export { default } from './SpaClassesPage';
